<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-head">WELCOME!</h1>
<p class="image-center"><img alt="" src="images/P8.jpg"/></p>
<p class="FBM-introc">Hello my fellow crocheters and friends! It’s a real pleasure to welcome you to this collection of crochet tributes to some of the most extraordinary women who have shaped our present or who are currently building our future.</p>
<p class="FBM-introc">Of course, we had to narrow the list down to 15 dolls and I am sure you will find that many are missing (Crochet Iconic Women Vol. 2, maybe?), but this is just a starting point; I strongly believe that the lives of these ladies are representative of the power of women and will be an endless source of inspiration. However, I wish that they should not only be taken as examples of successes and triumphs but mostly as stories of resilience, of overcoming impossible obstacles in the quest of the most amazing dreams.</p>
<p class="FBM-introc">The women in this book were not perfect but, with their complexities and flaws, they were all visionaries, brave, talented, smart, courageous and strong. Some of them had minds ahead of their time by many decades. Others sparked movements that became global and gave a voice to the voiceless.</p>
<p class="FBM-introc">I would love to see these dolls decorating your room or workplace, so whenever you look at them, they can be a reminder of what can be accomplished when one dares to dream. Or I hope you crochet them for little ones to play with and thus start the conversation about their extraordinary and influential lives. By the end of the book I am sure you will be able to include some modifications to the patterns, make hair curls longer or shorter and change the colours or skin tones to create your own special icons.</p>
<p class="FBM-introc">So let’s grab hooks and yarns and start crocheting!</p>
<p class="FBM-introHc"><i>Carla</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Welcome.vue?04728ed3